import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';

import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { OrganismModel } from '../partners/organisms/organism.model';
import { catchError } from 'rxjs/operators';
import * as CommonConstants from 'src/app/utils/common.constants';
import { env } from 'src/app/utils/common.constants';

@Injectable()
export class MasterService {
 

  civilityList = new BehaviorSubject<any>(null);
  nationailityList = new BehaviorSubject<any>(null);
  genderList = new BehaviorSubject<any>(null);
  groupList = new BehaviorSubject<any>(null);
  countryList = new BehaviorSubject<any>(null);
  partnerList = new BehaviorSubject<any>(null);


  constructor(private http: HttpClient) {
  }


  private handleError(error: any) {
    return Observable.throw(error || 'Server error');
  }



  /**
  * Consume  service to retrieve department list.
  * @param event current event
  * @returns Returns a list of departments.
  */
  getDepartments(): Observable<any> {
    return this.http.get(CommonConstants.GET_DEPARTMENT_MASTER).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  /**
      * Consume  service to retrieve employee list.
      * @param event current event
      * @returns Returns a list of employee.
      */
  getEmployees(): Observable<any> {
    return this.http.get(CommonConstants.GET_EMPLOYEE_MASTER).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  getEmployeesByPtype(pType: number): Observable<any> {
    return this.http.get(CommonConstants.GET_EMPLOYEE_MASTER + '?pType=' + pType).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  getEmployeesByPartnerId(pType: number, pId: number): Observable<any> {
    return this.http.get(CommonConstants.GET_EMPLOYEE_MASTER + '?pType=' + pType + '&partnerId=' + pId).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  /**
      * Consume  service to retrieve address list.
      * @param event current event
      * @returns Returns a list of address.
      */
  getAddress(): Observable<any> {
    return this.http.get(CommonConstants.GET_ADDRESS_MASTER).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  /**
 * Consume  service to retrieve Legal Form.
 * @param event current event
 * @returns Returns a list of Legal Form.
 */
  getLegalForm(): Observable<any> {
    return this.http.get(CommonConstants.GET_LEGALFORM_MASTER).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  /**
   * Consume  service to retrieve currency.
   * @param event current event
   * @returns Returns a list of currency
   */

  getCurrency(): Observable<any> {
    return this.http.get(CommonConstants.GET_CURRENCY_MASTER).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  /**
   * Consume  service to retrieve Country.
   * @param event current event
   * @returns Returns a list of Organisms
   */
  getCountry(): Observable<any> {
    return this.http.get(CommonConstants.GET_COUNTRY_MASTER).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  getCountryById(countryId): Observable<any> {
    return this.http.get(CommonConstants.GET_COUNTRY_MASTER + "?countryId=" + countryId).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  /**
       * Consume  service to retrieve Organisms.
       * @param event current event
       * @returns Returns a list of Organisms
       */
  getOrganisms(): Observable<any> {
    return this.http.get(CommonConstants.GET_ORGANISM_MASTER).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  /**
   * Consume  service to retrieve Locale.
   * @param event current event
   * @returns Returns a list of Locale
   */
  getLocale(): Observable<any> {
    return this.http.get(CommonConstants.GET_LOCALE_MASTER).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  /**
   * Consume  service to retrieve Nationality.
   * @param event current event
   * @returns Returns a list of Nationality
   */
  getNationality(): Observable<any> {
    return this.http.get(CommonConstants.GET_COUNTRY_MASTER).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  /**
   * Consume  service to retrieve Town.
   * @param event current event
   * @returns Returns a list of Town
   */
  getTown(): Observable<any> {
    return this.http.get(CommonConstants.GET_TOWN_MASTER).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }


  /**
   * Consume  service to retrieve Town.
   * @param event current event
   * @returns Returns a list of Town
   */
  getCategory(): Observable<any> {
    return this.http.get(CommonConstants.GET_CATEGORY_MASTER).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  getCategoryType(): Observable<any> {
    return this.http.get(CommonConstants.GET_CATEGORY_TYPE_MASTER).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  getSpecialities(): Observable<any> {
    return this.http.get(CommonConstants.GET_SPECIALITY_TYPE_MASTER).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  getSubSpecialities(): Observable<any> {
    return this.http.get(CommonConstants.GET_SUB_SPECIALITY_TYPE_MASTER).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  getHyperSpecialities(): Observable<any> {
    return this.http.get(CommonConstants.GET_HYPER_SPECIALITY_TYPE_MASTER).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  /**
   * Consume  service to retrieve Town.
   * @param event current event
   * @returns Returns a list of Town
   */
  getLanguages(): Observable<any> {
    return this.http.get(CommonConstants.GET_LANGUAGE_MASTER).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  getAddressTypes(): Observable<any> {
    return this.http.get(env + 'api/master/addressTypes').
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }



  getCivility(): Observable<any> {
    return this.http.get(env + 'api/master/civility').
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  getPartnerTypes(): Observable<any> {
    return this.http.get(env + 'api/master/partnerTypes').
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  getStatus(): Observable<any> {
    return this.http.get(env + 'api/master/status').
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  getAgmntQualtiy(): Observable<any> {
    return this.http.get(env + 'api/master/agrmntQuality').
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  getCertification(): Observable<any> {
    return this.http.get(env + 'api/master/certification').
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  getGender(): Observable<any> {
    return this.http.get(env + 'api/master/gender').
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  getGroup(): Observable<any> {
    return this.http.get(env + 'api/master/group').
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  getTitle(): Observable<any> {
    return this.http.get(env + 'api/master/title').
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  saveCountry(saveData): Observable<any> {
    return this.http.post(CommonConstants.env + 'api/master/country/create', saveData).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  searchMaster(searchData): Observable<any> {
    return this.http.post(CommonConstants.env + 'api/master/search', searchData).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  saveMaster(saveData): Observable<any> {
    return this.http.post(CommonConstants.env + 'api/master/create', saveData).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }


  getCivilityList() {
    if (!this.civilityList.value) {
      this.getCivility().subscribe(response => {
        if (response && response['result']) {
          // set value into behavior subject
          this.civilityList.next(response['result']);
        }
      })
    }
  }

  /**
 * Consume  service to retrieve Nationality.
 * @param event current event
 * @returns Returns a list of Nationality
 */
  getNationalitList() {
    if (!this.nationailityList.value) {
      this.getNationality().subscribe(response => {
        if (response && response['result']) {
          // set value into behavior subject
          this.nationailityList.next(response['result']);
        }
      })
    }
  }

  getGenderList() {
    if (!this.genderList.value) {
      this.getGender().subscribe(response => {
        if (response && response['result']) {
          // set value into behavior subject
          this.genderList.next(response['result']);
        }
      })
    }
  }

  getGroupList() {
    if (!this.groupList.value) {
      this.getGroup().subscribe(response => {
        if (response && response['result']) {
          // set value into behavior subject
          this.groupList.next(response['result']);
        }
      })
    }
  }

  getCountryList() {
    if (!this.countryList.value) {
      this.getCountry().subscribe(response => {
        if (response && response['result']) {
          // set value into behavior subject
          this.countryList.next(response['result']);
        }
      })
    }
  }

  getMastersByParamKey(params): Observable<any> {
    return this.http.get(CommonConstants.GET_MASTERS_BY_PARAM_KEY + "?paramKeys=" + params).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  getDistinctParamKeys(): Observable<any> {
    return this.http.get(CommonConstants.GET_DISTINCT_MASTERS_PARAM_KEY).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }


  
  getMastersCodesByParamKey(params): Observable<any> {
    return this.http.get(CommonConstants.GET_MASTERS_CODES_BY_PARAM_KEY + "?paramKeys=" + params).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  getPartners() {
    if (!this.partnerList.value) {
      this.http.get(env + 'api/partner/partners').subscribe(response => {
        if (response && response['result']) {
          // set value into behavior subject
          this.partnerList.next(response['result']);
        }
      })
    }
  }
  getPartnersByPartnerType(pType) {
    // if (!this.partnerList.value) {
      this.http.get(env + 'api/partner/partners?partnerType='+pType).subscribe(response => {
        if (response && response['result']) {
          // set value into behavior subject
          this.partnerList.next(response['result']);
        }
      })
    // }
  }
  getParnterListByParnterTypes(pType): Observable<any> {
    return this.http.get(env + 'api/partner/partners?partnerType='+pType).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  getExamType(): Observable<any> {
    return this.http.get(env + 'api/medicalfile/exam/types')
  }


  getDocTypes(): Observable<any> {
    return this.http.get(env + 'api/patient/documentType')
  }
  saveFileMaster(saveData) {
    return this.http.post(CommonConstants.env +'api/medicalfile/master/create', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  getMasterForms(formId) {
    return this.http.get(env + 'api/patient/form/defnition/'+formId)
  }
  errorHandler(error: any): void {
    throwError(error);
  };
  
  saveImage(saveData): Observable<any> {
    //console.log(JSON.stringify(saveData));
    return this.http.post(CommonConstants.env +'api/master/saveImage', saveData);
    //.pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  getPatientImageById(pType: number,pteId: number): Observable<any> {
    return this.http.get(CommonConstants.env + 'api/master/image/' +pType+'/'+pteId);
  }
}


